import moment from 'moment-timezone'
import { formatosDefault } from '@/core/constants'

const azDate = (date, format) => {
    const dateFormat = format || formatosDefault.DATA
    if (!date) return '-'

    const isString = typeof date === 'string'
    const parsed = isString ? moment.parseZone(date) : moment(date)

    return parsed.isValid() ? parsed.format(dateFormat) : '-'
}

export default azDate
